import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import FactorTemplateServices from "./FactorTemplate.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const resetFactorTemplate = () => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_FACTOR_TEMPLATE,
      payload: true,
    });
    dispatch({
      type: actions.GET_FACTOR_TEMPLATE,
      payload: {
        factorTemplates: [],
        factorTemplatesAll: [],
        factorTemplatesLength: 0,
      },
    });
    dispatch({
      type: actions.FACTOR_TEMPLATE_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.FACTOR_TEMPLATE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_FACTOR_TEMPLATE,
      payload: false,
    });
  }
};

export const getFactorTemplate = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_FACTOR_TEMPLATE,
      payload: true,
    });
    const resp = await FactorTemplateServices.getFactorTemplate(filters);
    // const resp2 = await FactorTemplateServices.getFactorTemplate({tipo_busqueda:filters.tipo_busqueda,filter:filters.filter});
    dispatch({
      type: actions.GET_FACTOR_TEMPLATE,
      payload: {
        factorTemplates: resp.data.data,
        // factorTemplatesAll: resp2.data.data,
        factorTemplatesAll: resp.data.data_año,
        factorTemplatesLength: resp.data.count,
      },
    });
    dispatch({
      type: actions.FACTOR_TEMPLATE_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.FACTOR_TEMPLATE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_FACTOR_TEMPLATE,
      payload: false,
    });
  }
};

export const getFactorTemplateById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_FACTOR_TEMPLATE_BY_ID,
      payload: true,
    });
    const resp = await FactorTemplateServices.getFactorTemplateById(id);
    dispatch({
      type: actions.GET_FACTOR_TEMPLATE_BY_ID,
      payload: resp.data,
    });
    dispatch({
      type: actions.FACTOR_TEMPLATE_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FACTOR_TEMPLATE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_FACTOR_TEMPLATE_BY_ID,
      payload: false,
    });
  }
};

export const saveFactorTemplate = (data, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_FACTOR_TEMPLATE,
        payload: true,
      });
      const resp = await FactorTemplateServices.saveFactorTemplate(data);
      const { factorTemplates, factorTemplatesAll, factorTemplatesLength } = getState().factorTemplate;
      dispatch({
        type: actions.GET_FACTOR_TEMPLATE,
        payload: {
          factorTemplates: [...factorTemplates, resp.data],
          factorTemplatesAll: [...factorTemplatesAll, {clasificacion:resp.data.list_periodicidad[0].clasificacion}],
          factorTemplatesLength: factorTemplatesLength + 1,
        },
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              if (ex.response && ex.response.data) {
                message = ex.response.data[0];
              } else {
                message = messages.errorMessage + " " + ex.response.statusText;
              }
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_FACTOR_TEMPLATE,
        payload: false,
      });
    }
  };

export const editFactorTemplate = (data, id, index, setShowModal, offset) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_FACTOR_TEMPLATE,
        payload: true,
      });
      const resp = await FactorTemplateServices.editFactorTemplate(id, data);
      const { factorTemplates, factorTemplatesAll, factorTemplatesLength } = getState().factorTemplate;
      factorTemplates[index] = resp.data;
      // factorTemplatesAll[index+offset] = resp.data;
      dispatch({
        type: actions.GET_FACTOR_TEMPLATE,
        payload: {
          factorTemplates: factorTemplates,
          factorTemplatesAll: factorTemplatesAll,
          factorTemplatesLength: factorTemplatesLength,
        },
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              if (ex.response && ex.response.data) {
                message = ex.response.data[0];
              } else {
                message = messages.errorMessage + " " + ex.response.statusText;
              }
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_FACTOR_TEMPLATE,
        payload: false,
      });
    }
  };

export const copyFactorTemplate = (data,setShowModalCopy) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_FACTOR_TEMPLATE,
      payload: true,
    });
    const resp = await FactorTemplateServices.copyFactorTemplate(data);
    const { factorTemplates, factorTemplatesAll, factorTemplatesLength } = getState().factorTemplate;
    const _resp = resp.data
    if(_resp.data.length>0){
      _resp.data.map(item=>{
        factorTemplates.push(item)
        factorTemplatesAll.push(item)
      })
    }
    dispatch({
      type: actions.GET_FACTOR_TEMPLATE,
      payload: {
        factorTemplates: factorTemplates,
        factorTemplatesAll: factorTemplatesAll,
        factorTemplatesLength: factorTemplatesLength + 1,
      },
    });
    dispatch({
      type: actions.FORM_COPY_FAIL,
      payload: _resp.respuestas_fallidas!==""||!_resp.respuestas_fallidas?_resp.respuestas_fallidas:"",
    });
    if(_resp.respuestas_fallidas===""||!_resp.respuestas_fallidas){
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
      setShowModalCopy(false)
    }
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            if(ex.response.data.Resultado){
              message = ex.response.data.Resultado;
            }else{
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    // dispatch({
    //   type: actions.FORM_COPY_FAIL,
    //   payload: message,
    // });
    toastr.error(message);
    dispatch({
      type: actions.FORM_COPY_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_FACTOR_TEMPLATE,
      payload: false,
    });
  }
};

export const deleteFactorTemplate = (id, index, offset) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_FACTOR_TEMPLATE,
        payload: true,
      });
      await FactorTemplateServices.deleteFactorTemplate(id);
      const { factorTemplates, factorTemplatesAll, factorTemplatesLength } = getState().factorTemplate;
      factorTemplates.splice(index, 1);
      // factorTemplatesAll.splice(index+offset, 1);
      dispatch({
        type: actions.GET_FACTOR_TEMPLATE,
        payload: {
          factorTemplates: factorTemplates,
          factorTemplatesAll: factorTemplatesAll,
          factorTemplatesLength: factorTemplatesLength - 1,
        },
      });
      dispatch({
        type: actions.FACTOR_TEMPLATE_FAIL,
        payload: "",
      });
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      // dispatch({
      //   type: actions.FACTOR_TEMPLATE_FAIL,
      //   payload: message,
      // });
      toastr.error(message);
    } finally {
      dispatch({
        type: actions.LOADING_FACTOR_TEMPLATE,
        payload: false,
      });
    }
  };
